export enum ServerAction {
    Start = "Start",
    Stop = "Stop",
}